import React from 'react'
import styled from 'styled-components'
import { CardHeader } from 'components'
import DateField from 'features/forms/components/DateField'
import Editor from 'features/forms/components/Editor'
import Switch from 'features/forms/components/Switch'
import TimeField from 'features/forms/components/TimeField'
import TextField from 'features/forms/components/TextField'
import { _ } from 'utils'
import NumberField from 'features/forms/components/NumberField'

const S = {
    Header: styled(CardHeader)`
        display: flex;
        align-items: center;
        margin: 0 10px 20px 10px;
    `,
}

const Settings = () => (
    <>
        <S.Header>{_('meeting.form.basic_setting_header')}</S.Header>
        <TextField
            name="title"
            label={_('meeting.form.title')}
            isRequired
        />
        <Switch
            name="closed"
            label={_('meeting.form.invite_only')}
            helperText={_('meeting.form.invite_only_helper_text')}
            lg={1/2}
            className="mb-3"
        />
        <Switch
            name="isWalkInMeeting"
            label={_('meeting.form.walk_in_meeting')}
            helperText={_('meeting.form.walk_in_meeting_helper_text')}
            lg={1/2}
            className="mb-3"
        />
        <Switch
            name="enableBreakoutRooms"
            label={_('meeting.form.enable_breakout_rooms')}
            helperText={_('meeting.form.enable_breakout_rooms_helper_text')}
        />
        <DateField
            name="startsAt"
            label={_('meeting.form.start_date')}
            minDate={new Date()}
            lg={1/2}
            isRequired
        />
        <TimeField
            name="startsAt"
            label={_('meeting.form.start_time')}
            lg={1/2}
            isRequired
        />
        <DateField
            name="endsAt"
            label={_('meeting.form.end_date')}
            minDate={new Date()}
            lg={1/2}
            isRequired
        />
        <TimeField
            name="endsAt"
            label={_('meeting.form.end_time')}
            lg={1/2}
            isRequired
        />
        <NumberField
            name="capacity"
            label={_('meeting.form.capacity')}
            lg={1/2}
            isRequired
        />
        <Editor
            name="description"
            label={_('meeting.form.description')}
            helperText={_('meeting.form.description_helper_text')}
        />
    </>
)

export default Settings
